import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { AppContext } from '../../../AppContext';
import EditIcon from '../../../assets/edit.svg';
import { ROUTES } from '../../../common/constants';
import GoBackButton from '../../../components/GoBackButton';
import LoaderComponent from '../../../components/LoaderComponent';
import Portal from '../../../components/Portal';
import PropertyContactModal from '../components/PropertyContactModal';
import PropertyContactTable from '../components/PropertyContactTable';
import PropertyTabs from '../components/PropertyTabs';
import { GET_PROPERTY } from '../graphql/Queries';

const PropertyContact = ({ match: { params: { id } = {} } = {}, history }) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const {
    state: { pageSize }
  } = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  const { data: { property } = {} } = useQuery(GET_PROPERTY, {
    variables: { id },
    onCompleted: () => {
      setLoading(false);
    },
    fetchPolicy: 'network-only',
    onError: () => {
      setLoading(false);
    }
  });

  const handleShowModal = () => {
    setShowModal(true);
  };

  return (
    <Card className="full-height-card card-body-padding">
      {showModal && (
        <PropertyContactModal
          showModal={showModal}
          setShowModal={setShowModal}
          productId={id}
        />
      )}
      <Portal portalId="header-left-content">
        <div className="d-flex align-center">
          <GoBackButton customLink={ROUTES?.PROPERTIES} />
          {property && <span className="portal-header">{property?.name}</span>}
        </div>
      </Portal>
      {!location?.pathname?.includes('/view') && (
        <Portal portalId="header-right-content">
          <Button
            className="common-button"
            icon={<PlusOutlined />}
            size="small"
            id="contact-table-add-btn"
            type="primary"
            onClick={handleShowModal}
          >
            Add Contact
          </Button>
        </Portal>
      )}
      {location?.pathname?.includes('/view') && (
        <Portal portalId="header-right-content">
          <Button
            className="common-button"
            icon={<img src={EditIcon} alt="save-icon" width={12} />}
            size="small"
            type="primary"
            onClick={() =>
              history?.push(
                `${ROUTES?.PROPERTIES}/edit${ROUTES?.CONTACTS}/${id}`
              )
            }
          >
            Edit
          </Button>
        </Portal>
      )}
      <PropertyTabs>
        {loading ? (
          <LoaderComponent />
        ) : (
          pageSize && <PropertyContactTable showModal={showModal} />
        )}
      </PropertyTabs>
    </Card>
  );
};

export default withRouter(PropertyContact);
